export default "__VITE_ASSET__0m7ijpIi__"